import dayjs from 'dayjs';

export function parseInactiveSince(value: unknown): number | null | undefined {
  if (typeof value === 'undefined') {
    // No data maintains the current state
    return;
  }

  if (typeof value === 'number') {
    // 0 will activate the object
    return value || null;
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
    const parsed = dayjs(value);
    if (parsed.isValid()) {
      const seconds = parsed.unix();
      return seconds === 0 ? undefined : seconds;
    }
  }

  const inactiveValue = Number(value);
  if (inactiveValue === 0) {
    return;
  }

  return isNaN(inactiveValue) ? null : inactiveValue;
}
